// These import errors can be ignored because the paths will be correct once this file has been copied from assets/psi-product to psi-product
// @ts-ignore
import type { LanguageKey } from 'util/locale';
// @ts-ignore
import { DeploymentConfig, SiloConfig } from "util/stdtypes";
import { firebaseConfig } from "./slot-3.firebase.config";

const siloConfig: Record<string, SiloConfig> = {
    zdf: {
        defaultLanguage: 'de-DE',
        loginBranding: {
            loginHeadingLabel: 'Zur Diskussion',
            loginSubheadingLabel:
                'Um am Test-Betrieb unseres Konversationsangebots ZDFspaces teilzunehmen, melde dich an oder lege einen Account an.',
            showCookieNotice: false,
            brandLogoImages: ['images/ZDF_logo.svg'],
        },
        standalonePageConfig: {
            header: {
                logo: {
                    desktop: require('./assets/logos/zdf/logo.svg'),
                    mobile: require('./assets/logos/zdf/logo.svg'),
                },
                alt: 'ZDF',
                logoLinkUrl: 'https://www.zdf.de/',
            },
        },
    },
};

export const siloLanguagesConfig: Record<string, LanguageKey[]> = {
    zdf: ['de-DE'],
    srg: ['fr-CH', 'de-CH', 'it-CH', 'rm-CH', 'en-US'],
};

export const deploymentConfigMap: Record<string, DeploymentConfig> = {
    production: {
        host: "https://main.psi.zdf.digital",
        firebaseConfig: firebaseConfig,
        storagePrefix: "https://firebasestorage.googleapis.com/v0//b/psi-product-zdfd-deploy-01.firebasestorage.app/o/",
        psiBrandName: "ZDFspaces",
        siloConfig: siloConfig,
        defaultLanguage: 'de-DE',
        defaultFeatures: {
            zdf: {
                account: {
                    accountvideovotingsetting: true,
                },
                article: {
                    greenquestionteaser: false,
                    kikaquestionteaser: true,
                },
            },
            srg: {
                question: {
                    premoderation: false,
                    "srg-disable-replies-on-audience-input": true,
                    "show-original-language": true,
                },
                profile: {
                    profilelanguage: true,
                    profiledisablephotoedit: true,
                },
                simplecomments: {
                    premoderation: false,
                },
            },
        },
        publicWebPushKey: "BMJtcDePJe281wDsKhEyZEH1JVz_4B5kXI_g7zB88dvdj4xltmdbm60otB_6ml3wQyyTxneifBzBx4HPuX55798",
        pushNotificationsOnParentWindow: true,
    },
};

export const domainToDeploymentMap: Record<string, string> = {
    "main.psi.zdf.digital": "production",
};

/**
 * Per-domain default UI language override.
 *
 * When several hostnames map to the same silo (e.g. `dialogue.rts.ch`,
 * `dialog.srf.ch`, `dialogo.rsi.ch` all serving the SRG silo), the silo-wide
 * `defaultLanguage` cannot distinguish between them. This map lets a deployment
 * pick a per-domain default that wins over `siloConfig.defaultLanguage` and
 * `deploymentConfig.defaultLanguage`, but stays below `?language_g=` URL
 * overrides in the precedence chain (see `useSiloLanguage` in `util/instance`).
 *
 * Keys are matched against `getDomain()` (`util/util.ts`) — the same lookup
 * `getDeploymentConfig` uses — so `'localhost'` and `'test'` are valid keys
 * for local dev and test setups. Matching is exact (no wildcards / suffixes).
 *
 * Empty by default — partners add their own domain → language pairs as needed.
 */
export const domainToLanguageMap: Record<string, LanguageKey> = {
    "main.psi.zdf.digital": "de-DE",
};
